<template>
  <!-- <v-flex xs12> -->
  <v-container
    flat
    class="primary mb-4"
    style="border-bottom-left-radius: 10px; border-bottom-right-radius: 10px"
  >
    <template v-if="oneChampionship">
      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="CardUser" style="border-radius: 6px">
            <v-layout row align-center>
              <v-flex xs2 sm2 text-xs-center>
                <v-avatar :size="avatarSize" color="grey lighten-4">
                  <v-img
                    :src="champ_logo"
                    alt="avatar"
                    v-if="champ_logo"
                    aspect-ratio="1"
                    class="grey lighten-4"
                    style="border-radius: 12px"
                    contain
                  />
                  <v-icon
                    :size="avatarSize*56/100"
                    color="grey lighten-1"
                    v-if="!champ_logo"
                  >fa-trophy</v-icon>
                </v-avatar>
              </v-flex>
              <v-flex>
                <v-card-title>
                  <v-layout row wrap align-center justify-start>
                    <h2 class="primary--text">{{oneChampionship.data.attributes.name}}</h2>
                    <!-- flat or icon are good to 1.5, fab or text are good to 2.0 -->
                    <!-- <v-spacer></v-spacer> -->
                    <!-- <v-btn small flat icon color="primary" @click="reloadChampsionship()"><v-icon small>mdi-reload</v-icon></v-btn> -->
                  </v-layout>
                </v-card-title>
              </v-flex>
            </v-layout>
            <!-- <v-divider light class="mt-2"></v-divider> -->
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs12 sm12>
          <v-tabs grow color="primary" slider-color="yellow" dark show-arrows>
            <v-tab
              v-for="item in items"
              :key="item.name"
              :to="`/campeonatos/${$route.params.id }/${item.path}`"
            >
              <!-- {{item.name}} -->
              <v-icon>{{item.icon}}</v-icon>
            </v-tab>
          </v-tabs>
          <v-card>
            <router-view></router-view>
          </v-card>
        </v-flex>
      </v-layout>
    </template>
    <template v-if="!oneChampionship">
      <card-loading load-text="Carregando"></card-loading>
    </template>
  </v-container>
  <!-- </v-flex> -->
</template>

<script>
import Games from "./ChampionshipDetails/gamesRounds.vue";
import Equipes from "./ChampionshipDetails/teams.vue";
import Grupos from "./ChampionshipDetails/groups.vue";
import Classification from "./ChampionshipDetails/classification.vue";
import Statistics from "./ChampionshipDetails/statistics.vue";
import lazygif from "@/assets/lazyload.gif";
import { mapActions, mapMutations } from "vuex";
import { mapState } from "vuex";

export default {
  data() {
    return {
      name: "Copa União Futsal",
      description: "A Corpa União se encontra em sua 4 edição",
      avatarSize: 62,
      model: 2,
      text: "Texto",
      lazyload: lazygif,
      items: [
        // equipes = fa-shield
        // groupos = fa-columns
        // jogos = fa-gamepad/ mdi-soccer
        // classification = fa-list-ol / mdi-format-list-numbered
        // stats = fa-medal
        { icon: "fa-shield-alt", path: "equipes", name: "Equipes", id: 1 },
        { icon: "fa-columns", path: "grupos", name: "Grupos", id: 2 },
        { icon: "mdi-soccer", path: "jogos", name: "Jogos", id: 3 },
        {
          icon: "fa-list-ol",
          path: "classificacao",
          name: "Classificação",
          id: 4
        },
        { icon: "fa-medal", path: "estatisticas", name: "Estatísticas", id: 5 }
      ]
    };
  },
  components: {
    Games,
    Equipes,
    Grupos,
    Classification,
    Statistics
  },
  computed: {
    champ_logo() {
      if (this.oneChampionship.data.attributes.logo) {
        return this.oneChampionship.data.attributes.logo;
      } else {
        return null;
      }
    },
    ...mapState({
      oneChampionship: state => state.Championship.oneChampionship,
      allChampionships: state => state.Championship.allChampionships
    })
  },
  methods: {
    reloadChampsionship() {
      this.getOneChampionship({ id: this.$route.params.id });
    },
    ...mapActions({
      show: "Users/show",
      getOneChampionship: "Championship/show",
      clearOneChampionship: "Championship/clearOneChampionship"
    }),
    ...mapMutations({
      clearChampTeams: "ChampTeam/clearChampTeams",
      setOneRoundGames: "Round/setOneRoundGames"
    })
  },
  watch: {
    oneChampionship(nv, ov) {
      if (nv) {
      } else if (nv == false) {
      }
    }
  },
  mounted() {
    this.getOneChampionship({ id: this.$route.params.id });
  },
  beforeDestroy() {
    this.clearOneChampionship();
    this.clearChampTeams();
    this.setOneRoundGames(null);
  }
};
</script>

<style scoped>
.CardUser {
  padding: 4px;
}

.round-card {
  border-radius: 10px !important;
}
.v-sheet {
  border-radius: 10px !important;
}
</style>